export enum ReportsActionTypes {
  API_RESPONSE_SUCCESS = "@@reports/API_RESPONSE_SUCCESS",
  API_RESPONSE_ERROR = "@@reports/API_RESPONSE_ERROR",

  GET_RENTALS_REPORT = "@@reports/GET_RENTALS_REPORT",
  GET_REVENUE_REPORT = "@@reports/GET_REVENUE_REPORT",
  GET_LOCATION_REPORT = "@@reports/GET_LOCATION_REPORT",
}
